import * as Yup from 'yup';
import { UpsertWorkspaceMutationVariables } from 'src/graphql/_generated';

export type WorkspaceFormValues = Omit<UpsertWorkspaceMutationVariables, 'workspaceId' | 'notificationScheduleTime'>;

export const workspaceValidationSchema = Yup.object({
  name: Yup.string().required('Required').max(200, 'Max 200 characters'),
  primaryContact: Yup.string().required('Required').email('Invalid email address').max(100, 'Max 100 characters'),
  organisationId: Yup.string().required('Required'),
  plan: Yup.string().required('Required'),
  isRestricted: Yup.boolean().required('Required'),
  currency: Yup.string()
    .max(3, 'Currency must be at most 3 characters long')
    .matches(/^[^\s]*$/, 'Currency must not contain spaces')
    .nullable(),
});

export const workspaceInitialValues: WorkspaceFormValues = {
  name: '',
  primaryContact: '',
  organisationId: '',
  plan: '',
  isRestricted: true,
  currency: undefined,
};
